export const environment :
{
  production: boolean;                              // Build-time: If True, optimize code.
  envName: 'dev' | 'staging' | 'prod';              // Runtime logic: If prod, run Live business logic.
  orgId: 'cems' | 'cims' | 'gpa' | 'gfd' | 'peri';
  parrotApiBaseUrl: string;
  apiBaseUrl: string;
  authServerUrl: string;
  clientSecret: string;
  clientId: string;
} = {
  production: false,
  envName: 'dev',
  parrotApiBaseUrl: 'https://hub-staging.storyshaper.io/mif_proxy/parrot', // if run using 'start dotnet watch run'
  apiBaseUrl: 'https://hub-staging.storyshaper.io/mif_proxy/subscription',
  authServerUrl: 'https://hub-staging.storyshaper.io/green',
  clientSecret: 'd7a3ddf0-2253-403f-bed8-720ec119e38e',
  clientId: 'mif_subscription',
  orgId: 'peri'
};
